import EmptyGroupBlock from './EmptyGroupBlock';
import { EmptyGroupBlockProps, EmptyGroupBlockValueProps } from './types';

export type { EmptyGroupBlockProps, EmptyGroupBlockValueProps };
export default EmptyGroupBlock;
